




















































































































































import { defineComponent, ref, watch, PropType } from "@vue/composition-api";
import Horizontal from "@/components/Atoms/Layout/Horizontal/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import { Cropper, FileInput, UploadEvent } from "./types";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default defineComponent({
  components: { Horizontal, OccButton, VueCropper },
  name: "ImageCropper",
  props: {
    aspectRatio: {
      type: Object,
      default: () => ({ x: 1, y: 1 })
    },
    note: {
      type: String,
      default: ""
    },
    defaultValue: {
      type: String,
      default: undefined
    },
    sizeRules: {
      type: Array as PropType<
        { height: number; width: number; size: number }[]
      >,
      required: true
    },
    containerStyle: {
      type: Object as PropType<{ maxHeight: number }>,
      default: undefined,
      required: false
    },
    previewImageStyle: {
      type: Object,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  emits: ["setUncroppedImage", "setImage", "crop"],
  setup(props, { emit }) {
    const unCroppedImagePath = ref<string>("");
    const croppedImagePath = ref<string>("");
    const isCropping = ref<boolean>(false);

    watch(
      () => props.defaultValue,
      newValue => {
        croppedImagePath.value = "";
        if (newValue) {
          unCroppedImagePath.value = newValue;
        }
      }
    );

    const fileSelectInput = ref<FileInput>();
    const cropper = ref<Cropper>();

    const onClickFileSelect = () => {
      // 切り出しモードは強制的に解除
      closeCropper();
      fileSelectInput.value?.click();
    };

    const onUploadFile = async (event: UploadEvent) => {
      const files = event.target.files;
      const file = files[0];

      setImage(file);
    };

    const resetCroppedImage = () => {
      croppedImagePath.value = "";
    };

    // 規定のサイズルールに合致しているか確認
    const ensureSize = (width: number, height: number, size: number) => {
      return props.sizeRules.some(
        rule =>
          width === rule.width && height === rule.height && size <= rule.size
      );
    };

    const setImage = async (file: File) => {
      if (!(file instanceof Blob)) return;

      const reader = new FileReader();
      reader.onload = async event => {
        if (!event.target) return;

        const image: string = event.target.result as string;
        unCroppedImagePath.value = image;
        emit("setUncroppedImage", unCroppedImagePath.value);

        try {
          const response = await fetch(unCroppedImagePath.value);
          if (response.status !== 200) {
            console.error("unCroppedImagePath loading is failed");
            return;
          }
          const tmpimage = new Image();
          tmpimage.onload = () => {
            if (
              ensureSize(
                tmpimage.naturalWidth,
                tmpimage.naturalHeight,
                file.size
              )
            ) {
              emit("setImage", unCroppedImagePath.value);
            }
          };
          tmpimage.src = unCroppedImagePath.value;
          // 新しい画像アップロードに成功したら、既存の切り抜き画像は破棄
          resetCroppedImage();
        } catch (error) {
          throw error;
        }
      };

      reader.readAsDataURL(file);
    };

    const openCropper = () => {
      isCropping.value = true;
    };

    const closeCropper = () => {
      isCropping.value = false;
    };

    const applyCrop = () => {
      if (!cropper.value) return;

      const croppedCanvas = cropper.value.getCroppedCanvas({
        width: props.sizeRules[0].width,
        height: props.sizeRules[0].height
      });
      if (!croppedCanvas) return;
      croppedImagePath.value = croppedCanvas.toDataURL();
      closeCropper();
      emit("crop", croppedImagePath.value);
    };

    const resetCropPosition = () => {
      cropper.value?.reset();
    };

    return {
      unCroppedImagePath,

      fileSelectInput,
      cropper,

      onClickFileSelect,
      onUploadFile,

      isCropping,
      croppedImagePath,
      openCropper,
      closeCropper,
      applyCrop,
      resetCropPosition
    };
  }
});
